import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Contact from './Contact';
import Gallery from './Gallery';
import Projects from './Projects';
import About from './About';          // ← New

function App() {
  const [language, setLanguage] = useState('en');
  const [menuOpen, setMenuOpen] = useState(false);

  const t = (en, id) => language === 'en' ? en : id;

  return (
    <Router>
      <div className="App">
        {/* Navbar */}
        <nav className="navbar">
          <div className="nav-container">
            <div className="logo">
              <span className="logo-icon">🏊‍♂️</span>
              <h1>PT Esawarna Gemilang</h1>
            </div>

            {/* Desktop Menu */}
            <div className="nav-links desktop">
              <Link to="/">Home</Link>
              <Link to="/about">About</Link>           {/* Now clickable */}
              <Link to="/gallery">Gallery</Link>
              <Link to="/projects">Projects</Link>
              <Link to="/contact">Contact</Link>

              <div className="language-switch">
                <button onClick={() => setLanguage('en')} className={language === 'en' ? 'active' : ''}>EN</button>
                <button onClick={() => setLanguage('id')} className={language === 'id' ? 'active' : ''}>ID</button>
              </div>
            </div>

            {/* Hamburger Menu Button */}
            <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? '✕' : '☰'}
            </button>
          </div>

          {/* Mobile Menu */}
          {menuOpen && (
            <div className="mobile-menu">
              <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
              <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
              <Link to="/gallery" onClick={() => setMenuOpen(false)}>Gallery</Link>
              <Link to="/projects" onClick={() => setMenuOpen(false)}>Projects</Link>
              <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link>

              <div className="mobile-language">
                <button onClick={() => setLanguage('en')} className={language === 'en' ? 'active' : ''}>EN</button>
                <button onClick={() => setLanguage('id')} className={language === 'id' ? 'active' : ''}>ID</button>
              </div>
            </div>
          )}
        </nav>

        <Routes>
          <Route path="/" element={<Home language={language} />} />
          <Route path="/about" element={<About language={language} />} />     {/* New Route */}
          <Route path="/gallery" element={<Gallery language={language} />} />
          <Route path="/projects" element={<Projects language={language} />} />
          <Route path="/contact" element={<Contact language={language} />} />
        </Routes>

        <footer>
          <p>© 2026 PT Esawarna Gemilang • Premium Custom Pool Builder Indonesia</p>
        </footer>
      </div>
    </Router>
  );
}

// ==================== HOME COMPONENT ====================
function Home({ language }) {
  const t = (en, id) => language === 'en' ? en : id;

  return (
    <main>
      <section id="home" className="hero">
        <div className="hero-content">
          <h1>PT Esawarna Gemilang</h1>
          <h2>{t('Built for Life', 'Dibangun untuk Kehidupan')}</h2>
          <p className="subtitle">
            {t('General Contractor and Supplier • Building Maintenance • Industrial Chemical and Water Treatment • Mechanical Electrical • Engineering Outsourcing')}
          </p>

          <Link to="/contact" className="btn quote-btn">
            {t('Get Free Quote', 'Dapatkan Penawaran Gratis')}
          </Link>

          {/* Your existing services (1-7) on Home remain here */}
          <div className="hero-services">
            {/* ... your current hero services content ... */}
          </div>
        </div>
      </section>
    </main>
  );
}

export default App;